const flash = {
  set ({type, message, code, data = {}}) {
    if (code) message = this.compile(data)[code]
    this.alert = {type, message}
  },

  now (options) {
    this.set(options)
    return this.pop()
  },

  pop () {
    const alert = Object.assign({}, this.alert)
    this.alert = {}
    return alert
  },

  compile (data) {
    return {
      'Already exists': `Sorte ${data['name']} existiert bereits`
    }
  }
}

export default flash



// WEBPACK FOOTER //
// ./app/frontend/services/flash.js